import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { OfferRequestConditionsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetOfferRequestConditionsLatest =
    OfferRequestConditionsTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetOfferRequestConditionsLatest = z.infer<
    typeof schemaLoanRequestResolver_GetOfferRequestConditionsLatest
>;

export type LoanRequestResolver_GetOfferRequestConditionsLatest = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetOfferRequestConditionsLatest
>;
